//SELECT
function selectApplink() {
  let selectHeader = document.querySelectorAll(".select__header_applink");
  let selectItem = document.querySelectorAll(".select__item_applink");

  selectHeader.forEach((item) => {
    item.addEventListener("click", function () {
      this.parentElement.classList.toggle("active");
    });
  });

  selectItem.forEach((item) => {
    item.addEventListener("click", function () {
      let dataLink = this.getAttribute("data-link");
      let text = this.innerText,
        select = this.closest(".select"),
        currentText = select.querySelector(".select__current");
      currentText.innerText = text;
      currentText.setAttribute("data-link", dataLink);
      select.classList.remove("active");
      let parentSelectNode = this.closest(".applink_select");
      // parentSelectNode.nextSibling.firstChild;
      let btnDownload = parentSelectNode.nextElementSibling.firstElementChild;
      btnDownload.setAttribute("href", dataLink);
    });
  });
}
// SLICE TEXT FOR LOGO
function sliceText() {
  let arrTexts = document.querySelectorAll(".item_applinks_name");
  for (let textLogo of arrTexts) {
    if (textLogo.innerText.length > 9) {
      let slicedText = textLogo.innerText.slice(0, 10);
      textLogo.innerText = slicedText + "...";
    }
  }
}

function getLogosID() {
  let arrLogosId = [];
  for (let logoEl of document.querySelectorAll(".item_applinks_logo_name")) {
    if (logoEl.id != "") arrLogosId.push(logoEl.id);
  }
  return arrLogosId;
}
function setClickLog() {
  let logosId = getLogosID();
  for (let logoId of logosId) {
    let blockId = logoId.replace("_logo", "_block");
    document.getElementById(logoId).addEventListener("click", function () {
      hideAllBlocks();
      document.getElementById(blockId).classList.remove("hide_block");
      document
        .getElementById(blockId)
        .scrollIntoView({ block: "center", behavior: "smooth" });
    });
  }
}
function hideAllBlocks() {
  for (let blockEl of document.querySelectorAll(".block_applinks_content_bg")) {
    blockEl.classList.add("hide_block");
  }
}
setClickLog();

sliceText();
selectApplink();
